/** Rilevamento binario Vetrina (sito) vs App mobile leggera. */

export const APP_MODE_KEY = "6amico_app_mode";

export function isAppPath(pathname = "") {
  return /^\/(?:app|mobile)(?:\/|$)/.test(pathname || "");
}

export function isEmbedQuery(search = "") {
  const q = typeof search === "string" ? search : "";
  return /(?:^|[?&])(?:embed|webview)=1(?:&|$)/.test(q);
}

export function prefersAppMode() {
  if (typeof window === "undefined") return false;
  try {
    if (localStorage.getItem(APP_MODE_KEY) === "app") return true;
    if (localStorage.getItem(APP_MODE_KEY) === "vetrina") return false;
  } catch {
    /* ignore */
  }
  return window.matchMedia("(max-width: 767px)").matches;
}

export function setAppModePreference(mode) {
  if (typeof window === "undefined") return;
  try {
    if (mode === "app" || mode === "vetrina") {
      localStorage.setItem(APP_MODE_KEY, mode);
    } else {
      localStorage.removeItem(APP_MODE_KEY);
    }
  } catch {
    /* ignore */
  }
}

/** URL interno con shell minima per iframe / webview app. */
export function withEmbedParams(path, extra = {}) {
  const base =
    path.startsWith("http://") || path.startsWith("https://")
      ? path
      : `${typeof window !== "undefined" ? window.location.origin : ""}${path.startsWith("/") ? path : `/${path}`}`;
  const u = new URL(base);
  u.searchParams.set("embed", "1");
  u.searchParams.set("webview", "1");
  for (const [k, v] of Object.entries(extra)) {
    if (v != null && v !== "") u.searchParams.set(k, String(v));
  }
  return u.pathname + u.search + u.hash;
}

export function appWebviewUrl(targetPath) {
  const embedded = withEmbedParams(targetPath);
  return `/app/webview?url=${encodeURIComponent(embedded)}`;
}

/** Percorso canonico scheda comune (desktop e mobile). */
export function appComunePath(slug) {
  return `/comune/${slug}`;
}

export function sosUrl() {
  return "/emergenza";
}
